import React from 'react';
import PropTypes from 'prop-types';
import { renderContainerChildren } from '../../utils/RenderUtil.js';
import { useBreakpointRef } from '../../hooks/useBreakpointRef.js';
import { useContainerProps } from '../../hooks/useContainerProps.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
var BREAKPOINTS = Object.freeze([724, 900]);
var BREAKPOINT_VALUES = Object.freeze([{
  section: {
    padding: '24px 0'
  },
  sectionInner: {
    padding: '0 16px'
  }
}, {
  section: {
    padding: '30px 0'
  },
  sectionInner: {
    padding: '0 24px'
  }
}, {
  section: {
    padding: '30px 0'
  },
  sectionInner: {
    padding: '0 48px'
  }
}]);
var TYPE_OVERRIDES = Object.freeze({
  chart: {
    noPadding: true
  }
});

/** renders a div that is styled to fill the section area */
var Section = function Section(props) {
  props = useContainerProps(props);
  var _useBreakpointRef = useBreakpointRef({
      breakpoints: BREAKPOINTS,
      breakpointValues: BREAKPOINT_VALUES
    }),
    ref = _useBreakpointRef.ref,
    breakpointValue = _useBreakpointRef.breakpointValue;
  var _props = props,
    className = _props.className,
    dataObjectType = _props.dataObjectType,
    noBorder = _props.noBorder,
    noBottomPadding = _props.noBottomPadding,
    noPadding = _props.noPadding,
    title = _props.title,
    _props$type = _props.type,
    type = _props$type === void 0 ? 'fullwidth' : _props$type;
  var overrides = TYPE_OVERRIDES[type] || {};
  var sectionStyle = function sectionStyle() {
    if (!overrides.noPadding) {
      if (noBottomPadding) {
        var sectionPadding = breakpointValue && Object.assign({}, breakpointValue.section);
        if (sectionPadding) {
          sectionPadding.padding = sectionPadding.padding.concat(' 0');
          return sectionPadding;
        }
      }
      return breakpointValue && breakpointValue.section;
    }
    return {
      padding: 0
    };
  };
  var sectionInnerStyle = !overrides.noPadding ? breakpointValue && breakpointValue.sectionInner : {
    padding: 0
  };
  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['section', type, className, {
      'no-border': noBorder,
      'no-padding': noPadding
    }]),
    ref: ref,
    style: sectionStyle(),
    "data-object-type": dataObjectType
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-inner",
    style: sectionInnerStyle,
    "data-action": "section-inner"
  }, title && /*#__PURE__*/React.createElement("h2", {
    className: "sr-only"
  }, title), renderContainerChildren(props)));
};
Section.displayName = "Section";
Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataObjectType: PropTypes.string,
  noBorder: PropTypes.bool,
  noPadding: PropTypes.bool,
  noBottomPadding: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(['cards', 'chart', 'fullwidth', 'list']),
  hideLoader: PropTypes.bool
};
export { Section };